import * as React from 'react';
import { SvgWrapper } from '../utils';
import type { IconProps } from '../utils';

const svg = (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 28.08 41" width="1em" height="1em">
    <g data-name="Layer 2">
      <g
        data-name="Layer 1"
        fill="fj-icons-bg-color"
        stroke="fj-icons-primary-color"
        strokeLinecap="round"
        strokeLinejoin="round"
      >
        <path d="M27.58 40.5V28.73c0-5-4.6-9.07-10.22-9.07h-6.64C5.1 19.66.5 23.74.5 28.73V40.5z" />
        <ellipse cx={14.04} cy={10.35} rx={9.92} ry={9.85} />
      </g>
    </g>
  </svg>
);

const User = ({
  style = {
    primaryColor: 'currentColor',
    bgColor: 'transparent',
  },
  size = '1em',
  active = false,
  ...rest
}: IconProps) => (
  <SvgWrapper style={style} size={size} active={active} {...rest}>
    {svg}
  </SvgWrapper>
);

export default User;
